import { BreakpointsOptions } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    mobile: true
    mobileLarge: true
    tablet: true
    laptop: true
    desktop: true
  }
}

export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    mobile: 300,
    mobileLarge: 420,
    tablet: 600,
    laptop: 900,
    desktop: 1200,
  },
}

export default breakpoints
